export default {"src":"/_next/static/media/indexing.f41e9ca0.svg","height":1089,"width":1683,"blurWidth":0,"blurHeight":0};